module.exports = require("./jmc.d.ts");